import { createAction } from 'redux-actions';
import {
  VideoModel,
  VideoAspectRatio,
  VideoCreatorErrorCode,
  VideoCreatorPendingGeneration,
} from '../../types/store';
import {
  PapiDeviation,
  PapiDreamsofartInitVideo,
  PapiDreamsofartRestrictions,
} from '@wix/da-papi-types';
import { createCallbackActionCreator } from '@wix/da-shared-react/pkg/Stream/helpers';

export const updateVideoCreatorPrompt = createAction(
  'STUDIO.VIDEO_CREATOR_UPDATE_PROMPT',
  (prompt: string) => ({ prompt })
);

export const updateVideoCreatorModel = createAction(
  'STUDIO.VIDEO_CREATOR_UPDATE_MODEL',
  (model: VideoModel) => ({ model })
);

export const updateVideoCreatorAspectRatio = createAction(
  'STUDIO.VIDEO_CREATOR_UPDATE_ASPECT_RATIO',
  (aspectRatio: VideoAspectRatio) => ({ aspectRatio })
);

export const updateVideoCreatorDuration = createAction(
  'STUDIO.VIDEO_CREATOR_UPDATE_DURATION',
  (duration: number) => ({ duration })
);

export const updateVideoCreatorSound = createAction(
  'STUDIO.VIDEO_CREATOR_UPDATE_SOUND',
  (sound: boolean) => ({ sound })
);

export const updateVideoCreatorStatus = createAction(
  'STUDIO.VIDEO_CREATOR_UPDATE_STATUS',
  (status: 'idle' | 'busy') => ({ status })
);

export const updateVideoCreatorReferenceDeviation = createAction(
  'STUDIO.VIDEO_CREATOR_UPDATE_REFERENCE_DEVIATION',
  (referenceDeviation: PapiDeviation | undefined) => ({ referenceDeviation })
);

export const updateVideoCreatorErrorCode = createAction(
  'STUDIO.VIDEO_CREATOR_UPDATE_ERROR_CODE',
  (errorCode: VideoCreatorErrorCode) => ({ errorCode })
);

export const resetVideoCreator = createAction('STUDIO.VIDEO_CREATOR_RESET', () => ({}));

export const initializeVideoCreator = createAction(
  'STUDIO.VIDEO_CREATOR_INITIALIZE',
  (initData: PapiDreamsofartInitVideo) => ({ initData })
);

export const updateVideoCreatorRestrictions = createAction(
  'STUDIO.VIDEO_CREATOR_UPDATE_RESTRICTIONS',
  (restrictions: PapiDreamsofartRestrictions) => ({ restrictions })
);

export const generateVideo = createAction('STUDIO.VIDEO_CREATOR_GENERATE', () => ({}));

export const setFirstGenModalSeen = createAction(
  'STUDIO.VIDEO_CREATOR_SET_FIRST_GEN_MODAL_SEEN',
  () => ({})
);

export const fetchGenerationCost = createAction(
  'STUDIO.VIDEO_CREATOR_FETCH_GENERATION_COST',
  (modelId: string, duration: number, sound: boolean) => ({
    modelId,
    duration,
    sound,
  })
);

export const updateVideoCreatorPricePoints = createAction(
  'STUDIO.VIDEO_CREATOR_UPDATE_PRICE_POINTS',
  (pricePoints: number) => ({ pricePoints })
);

export const updateVideoCreatorLowestPricePoints = createAction(
  'STUDIO.VIDEO_CREATOR_UPDATE_LOWEST_PRICE_POINTS',
  (lowestPricePoints: number) => ({ lowestPricePoints })
);

export const updateVideoCreatorIsCalculatingCost = createAction(
  'STUDIO.VIDEO_CREATOR_UPDATE_IS_CALCULATING_COST',
  (isCalculatingCost: boolean) => ({ isCalculatingCost })
);

export const updateVideoCreatorGenerationCostModel = createAction(
  'STUDIO.VIDEO_CREATOR_UPDATE_GENERATION_COST_MODEL',
  (modelId: string) => ({ modelId })
);

export const addVideoCreatorPendingGeneration = createAction(
  'STUDIO.VIDEO_CREATOR_ADD_PENDING_GENERATION',
  (pendingGeneration: VideoCreatorPendingGeneration) => ({ pendingGeneration })
);

export const removeVideoCreatorPendingGeneration = createAction(
  'STUDIO.VIDEO_CREATOR_REMOVE_PENDING_GENERATION',
  (generationId: number) => ({ generationId })
);

export const updateVideoCreatorModelsExpanded = createAction(
  'STUDIO.VIDEO_CREATOR_UPDATE_MODELS_EXPANDED',
  (modelsExpanded: boolean) => ({ modelsExpanded })
);

/** Action type string; must match stream `fetchNextCallback` stored in Redux (see handleInitializeVideoCreator). */
export const FETCH_NEXT_VIDEO_GENERATIONS_TYPE =
  'STUDIO.VIDEO_CREATOR_FETCH_NEXT_VIDEO_GENERATIONS';

export const fetchNextVideoGenerations = createCallbackActionCreator(
  FETCH_NEXT_VIDEO_GENERATIONS_TYPE
);

export const saveVideo = createAction(
  'STUDIO.VIDEO_CREATOR_SAVE_VIDEO',
  (generationId: number) => ({ generationId })
);
